<aside
  class="fixed top-14 left-0 bottom-0 z-40 flex w-60 flex-col overflow-x-hidden overflow-y-auto bg-maersk-navy text-white shadow-xl transition-[transform,width] duration-200"
  [class.-translate-x-full]="!isOpen"
  [class.translate-x-0]="isOpen"
  [class.md:translate-x-0]="true"
  [class.sidebar-collapsed]="isCollapsed"
  [class.md:w-16]="isCollapsed">

  <nav class="flex-1 py-4">
    @for (group of navGroups; track group.title; let first = $first) {
      @if (!first) {
        <div class="mx-4 my-3 border-t border-white/10"></div>
      }
      <div class="sidebar-group-title px-4 pt-1 pb-1">
        <span class="text-xs font-semibold tracking-wider text-white/55">
          {{ group.title }}
        </span>
      </div>
      @for (item of group.items; track item.path) {
        <a
          [routerLink]="item.path"
          routerLinkActive="active"
          class="sidebar-link"
          [attr.aria-label]="item.label"
          [attr.title]="isCollapsed ? item.label : null"
          (click)="linkClicked.emit()">
          <i class="fas {{ item.icon }}"></i>
          <span class="sidebar-link-label">{{ item.label }}</span>
        </a>
      }
    }
  </nav>

  <!-- Service meta -->
  <div class="sidebar-service-meta mt-auto border-t border-white/10">
    <app-service-meta />
  </div>
</aside>
